import { ApisauceInstance, create } from 'apisauce';

import { apiMethods, Config } from '@nw/shared/config';

import { getAccessToken } from '../../../utils/AccountsStorageUtils';
import { networkCallWithApisauce } from '../../../utils/AuthAPIUtils';

import {
  GetAuthCodeRequestType,
  GetAuthCodeResponseType,
  GetUserProfileResponseType,
  LoginOTPVerifyRequestType,
  LoginOTPVerifyResponseType,
  LoginWithPhoneOTPRequestType,
  LoginWithPhoneOTPResponseType,
  RefreshAuthTokensRequestType,
  RefreshAuthTokensResponseType,
  SendOtpToUserWithPhoneNumberRequestType,
  SendOTPToVerifyEmailRequestType,
  UpdateUserProfileRequestType,
  UserCreateWithPhoneRequestType,
  UserCreateWithPhoneResponseType,
  VerifyEmailOTPRequestType,
  VerifyRegistrationOfPhoneNumberRequestType,
  VerifyRegistrationOfPhoneNumberResponseType
} from './types';

import { IbUserAccountsAPIServiceTypes } from '.';

class IbUserAccountsAPIService implements IbUserAccountsAPIServiceTypes {
  api: ApisauceInstance;
  networkCallWithAPISauce: any;

  constructor(networkCallWithAPISauce: any) {
    this.api = create({
      baseURL: `${Config['IB_USER_ACCOUNT_URL']}`
    });
    this.networkCallWithAPISauce = networkCallWithAPISauce;
  }

  getAuthCode(
    requestObject: GetAuthCodeRequestType
  ): Promise<GetAuthCodeResponseType> {
    return this.networkCallWithAPISauce(
      this.api,
      'code/v1/',
      requestObject,
      apiMethods.post
    );
  }

  userLoginWithPhoneNumber(
    requestObject: LoginWithPhoneOTPRequestType
  ): Promise<LoginWithPhoneOTPResponseType> {
    return networkCallWithApisauce(
      this.api,
      'user/login/phone_number/v1/',
      requestObject,
      apiMethods.post
    );
  }

  userCreateWithPhoneNumber(
    requestObject: UserCreateWithPhoneRequestType
  ): Promise<UserCreateWithPhoneResponseType> {
    return networkCallWithApisauce(
      this.api,
      'user/create_with_phone_number/v1/',
      requestObject,
      apiMethods.post
    );
  }

  sendOtpToUserWithPhoneNumber(
    requestObject: SendOtpToUserWithPhoneNumberRequestType
  ): Promise<void> {
    return networkCallWithApisauce(
      this.api,
      'send_otp_to_user_with_phone_number/v1/',
      requestObject,
      apiMethods.post
    );
  }

  loginOtpVerify(
    requestObject: LoginOTPVerifyRequestType
  ): Promise<LoginOTPVerifyResponseType> {
    return networkCallWithApisauce(
      this.api,
      'login_otp/verify/v1/',
      requestObject,
      apiMethods.post
    );
  }

  verifyRegistrationOfPhoneNumber(
    requestObject: VerifyRegistrationOfPhoneNumberRequestType
  ): Promise<VerifyRegistrationOfPhoneNumberResponseType> {
    return networkCallWithApisauce(
      this.api,
      'user/verify_registration_of_phone_number/v1/',
      requestObject,
      apiMethods.post
    );
  }

  getUserProfileData(): Promise<GetUserProfileResponseType> {
    return this.networkCallWithAPISauce(
      this.api,
      'user/profile/v1/',
      {},
      apiMethods.get
    );
  }

  updateUserProfile(
    requestObject: UpdateUserProfileRequestType
  ): Promise<void> {
    return this.networkCallWithAPISauce(
      this.api,
      'user/update/profile/v1/',
      requestObject,
      apiMethods.post
    );
  }

  sendOTPToVerifyEmail(
    requestObject: SendOTPToVerifyEmailRequestType
  ): Promise<void> {
    return this.networkCallWithAPISauce(
      this.api,
      'send_otp_to_user_with_email/v1/',
      requestObject,
      apiMethods.post
    );
  }

  verifyEmailOTP(requestObject: VerifyEmailOTPRequestType): Promise<void> {
    return this.networkCallWithAPISauce(
      this.api,
      'user_account/email/verify/v1/',
      requestObject,
      apiMethods.post
    );
  }

  getRefreshToken = (
    requestObject: RefreshAuthTokensRequestType
  ): Promise<RefreshAuthTokensResponseType> => {
    return this.networkCallWithAPISauce(
      this.api,
      `refresh_auth_tokens/v1/`,
      requestObject,
      apiMethods.post,
      {
        getAccessToken: () => getAccessToken()
      }
    );
  };

  userLogout = (): Promise<void> => {
    return this.networkCallWithAPISauce(
      this.api,
      `user/logout/v1/`,
      {},
      apiMethods.post
    );
  };
}

export { IbUserAccountsAPIService };
